<div class="container-title ng-star-inserted">
  <h3 class="mb-0 ng-star-inserted">
    <div class="d-flex align-items-center">
      <div class="pl-2 pr-2">
        <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
          <img src="assets/images/grid-back.png">
        </a>
      </div>
      <div class="">View Template</div>
    </div>
  </h3>
</div>
<div class="row card p-2">
  <div class="col-lg-12 pt-2">
    <div class="form-group row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        @if (dropdownList) {
          <div>
            <select class="form-control" (change)="valueChange($event)">
              <option value="">Select</option>
              @for (option of options; track option) {
                <option [value]="getVal(option)">{{option.name}}</option>
              }
            </select>
          </div>
        }
        @if (show) {
          @if (templateField && data && show) {
            <dhs-form [action]="'ADD'" [fieldGroup]="templateField"
              [config]="config" (saveFinished)="onSaveFinished($event)"
              [data]="data" [customButton]='btn' (cancel)='redirect();'  >
            </dhs-form>
          }
        }

        <div class="col-md-3 col-lg-3 col-xl-3"></div>
      </div>
    </div>
  </div>
</div>